import { Poll } from '../../../../../../../db/polls/types';
import { DueDateType } from '../../../../../../../db/types';
import { getIsPollOpen } from '../../../../helpers';

export function getCanSeeAutoPollOverlay(poll: Poll | null) {
  if (!poll) return false;

  const isPollManual = poll.preferences.dueDateType === DueDateType.MANUAL;
  if (isPollManual) return false;

  const areResultsVisibleAfterDeadline = poll.preferences.deadlineFirst;
  if (!areResultsVisibleAfterDeadline) return false;

  const isPollOpen = getIsPollOpen(poll);
  if (!isPollOpen) return false;

  return true;
}
